import React from "react";
import { useNavigate } from "react-router-dom";

import { Card, Row, Col, Button } from "react-bootstrap";

import {
  Images,
  BoxSeam,
  StarFill,
  Stars,
  ArrowRight,
  BoxArrowRight,
  HouseDoor,
  ShieldCheck,
  FileEarmarkPdfFill,
} from "react-bootstrap-icons";

import "./AdminMenu.css";

export default function AdminMenu() {
  const navigate = useNavigate();

  /* =========================================================
     CERRAR SESIÓN
  ========================================================= */

  const cerrarSesion = () => {
    sessionStorage.removeItem("gj_admin_token");
    sessionStorage.removeItem("gj_admin_usuario");

    navigate("/login", {
      replace: true,
    });
  };

  /* =========================================================
     VOLVER AL SITIO
  ========================================================= */

  const volverSitio = () => {
    navigate("/");
  };

  return (
    <div className="admin-menu-page">
      <div className="admin-menu-container">
        {/* =============================================
            CABECERA
        ============================================= */}

        <div className="admin-menu-header">
          <div>
            <div className="admin-menu-kicker">
              <ShieldCheck />
              PANEL ADMINISTRATIVO
            </div>

            <h1>G&amp;J Frío Industrial y Doméstico</h1>

            <p>Selecciona el módulo que deseas administrar.</p>
          </div>

          <div className="admin-menu-header-actions">
            <Button variant="outline-primary" size="sm" onClick={volverSitio}>
              <HouseDoor className="me-2" />
              Volver al sitio
            </Button>

            <Button variant="outline-danger" size="sm" onClick={cerrarSesion}>
              <BoxArrowRight className="me-2" />
              Cerrar sesión
            </Button>
          </div>
        </div>

        {/* =============================================
            TARJETAS
        ============================================= */}

        <Row className="g-4 justify-content-center">
          {/* ===========================================
              01 - CARRUSEL PRINCIPAL
          =========================================== */}

          <Col md={6} lg={4}>
            <Card
              className="admin-menu-card"
              onClick={() => navigate("/admin-carousel")}
            >
              <Card.Body>
                <div className="admin-menu-card-top">
                  <div className="admin-menu-icon admin-menu-icon-carousel">
                    <Images />
                  </div>

                  <span className="admin-menu-number">01</span>
                </div>

                <div className="admin-menu-card-content">
                  <span className="admin-menu-card-label">PORTADA</span>

                  <h2>Carrusel principal</h2>

                  <p>
                    Administra las imágenes principales que aparecen en la
                    portada del sitio web.
                  </p>
                </div>

                <div className="admin-menu-card-footer">
                  <span>Administrar portadas</span>

                  <ArrowRight />
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* ===========================================
              02 - CATÁLOGO
          =========================================== */}

          <Col md={6} lg={4}>
            <Card
              className="admin-menu-card"
              onClick={() => navigate("/admin-productos")}
            >
              <Card.Body>
                <div className="admin-menu-card-top">
                  <div className="admin-menu-icon admin-menu-icon-products">
                    <BoxSeam />
                  </div>

                  <span className="admin-menu-number">02</span>
                </div>

                <div className="admin-menu-card-content">
                  <span className="admin-menu-card-label">CATÁLOGO</span>

                  <h2>Productos</h2>

                  <p>
                    Administra los productos del catálogo general, imágenes,
                    información y categorías.
                  </p>
                </div>

                <div className="admin-menu-card-footer">
                  <span>Administrar catálogo</span>

                  <ArrowRight />
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* ===========================================
              03 - DESTACADOS
          =========================================== */}

          <Col md={6} lg={4}>
            <Card
              className="admin-menu-card"
              onClick={() => navigate("/admin-destacados")}
            >
              <Card.Body>
                <div className="admin-menu-card-top">
                  <div className="admin-menu-icon admin-menu-icon-featured">
                    <StarFill />
                  </div>

                  <span className="admin-menu-number">03</span>
                </div>

                <div className="admin-menu-card-content">
                  <span className="admin-menu-card-label">PORTADA</span>

                  <h2>Productos destacados</h2>

                  <p>
                    Administra los productos destacados de la página principal,
                    incluyendo Grupo 1 y Grupo 2.
                  </p>
                </div>

                <div className="admin-menu-card-footer">
                  <span>Administrar destacados</span>

                  <ArrowRight />
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* ===========================================
              04 - NUEVOS PRODUCTOS
          =========================================== */}

          <Col md={6} lg={4}>
            <Card
              className="admin-menu-card"
              onClick={() => navigate("/admin-nuevos")}
            >
              <Card.Body>
                <div className="admin-menu-card-top">
                  <div className="admin-menu-icon admin-menu-icon-new">
                    <Stars />
                  </div>

                  <span className="admin-menu-number">04</span>
                </div>

                <div className="admin-menu-card-content">
                  <span className="admin-menu-card-label">NOVEDADES</span>

                  <h2>Nuevos productos</h2>

                  <p>
                    Administra los productos nuevos que aparecen en la sección
                    de novedades de la página principal.
                  </p>
                </div>

                <div className="admin-menu-card-footer">
                  <span>Administrar nuevos</span>

                  <ArrowRight />
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* ===========================================
              05 - DOCUMENTOS PDF
          =========================================== */}

          <Col md={6} lg={4}>
            <Card
              className="admin-menu-card"
              onClick={() => navigate("/admin-documentos")}
            >
              <Card.Body>
                <div className="admin-menu-card-top">
                  <div className="admin-menu-icon admin-menu-icon-pdf">
                    <FileEarmarkPdfFill />
                  </div>

                  <span className="admin-menu-number">05</span>
                </div>

                <div className="admin-menu-card-content">
                  <span className="admin-menu-card-label">DOCUMENTACIÓN</span>

                  <h2>Documentos PDF</h2>

                  <p>
                    Administra los manuales, catálogos y guías técnicas
                    disponibles en el Centro de Ayuda.
                  </p>
                </div>

                <div className="admin-menu-card-footer">
                  <span>Administrar documentos</span>

                  <ArrowRight />
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}
